import { URLS } from '../../../consts/endpoints';
import { postData } from '../../../utils/http';
import { isArray, isArrayEmpty, isDefined } from '../../../utils/isDefined';
import createNumbersArray from '../../../utils/createNumbersArray';
import { COUNTRY_CODE } from '../../../consts/initialValues';

export const MAX_NUMBERS_TO_CHECK = 100;

const fetchLookupOperators = async ranges => {
  const danishRanges = ranges.filter(isDanishRange);

  if (!danishRanges.length) {
    return ranges;
  }

  const numbersToSearch = buildNumbersToSearch(danishRanges);

  const { data: lookupData } = await postData({
    url: `${URLS.LOOKUP}`,
    data: { numbers: numbersToSearch.map(el => el.toString()) }
  });

  const lookupArray = isArray(lookupData) ? lookupData : [];

  return mergeOperatorsIntoRanges(ranges, lookupArray);
};

export default fetchLookupOperators;

export const isDanishRange = range => {
  return range.range_from.toString().startsWith(COUNTRY_CODE.danish);
};

export const buildNumbersToSearch = ranges => {
  return ranges.reduce((arr, el) => {
    const { range_from, range_up_to_incl } = el;

    if (range_from === range_up_to_incl) {
      return [...arr, range_from];
    }
    if (range_up_to_incl - range_from > MAX_NUMBERS_TO_CHECK) {
      return arr.concat(
        createNumbersArray(range_from, range_from + MAX_NUMBERS_TO_CHECK - 1)
      );
    }
    return arr.concat(createNumbersArray(range_from, range_up_to_incl));
  }, []);
};

export const mergeOperatorsIntoRanges = (ranges, lookupArray) => {
  return ranges.map(el => {
    const rangeFromStr = el.range_from.toString();

    const matches = lookupArray.filter(item => {
      if (!item) return false;

      const numStr = item.number.toString();

      const mappedNumber =
        rangeFromStr.length > numStr.length
          ? Number(
              rangeFromStr.slice(0, rangeFromStr.length - numStr.length) +
                numStr
            )
          : Number(numStr);
      return (
        mappedNumber >= el.range_from && mappedNumber <= el.range_up_to_incl
      );
    });

    if (isArrayEmpty(matches)) return el;

    return {
      ...el,
      service_operator: [
        ...new Set(matches.map(m => m.servoper_N).filter(el => isDefined(el)))
      ]
    };
  });
};
